import { html } from 'lit';
import { Share } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-share')
export class PdsIconShare extends PdsIcon {
  @state()
  icon = Share;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
